import axios from 'axios';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
window.gsap = gsap;
gsap.registerPlugin(ScrollTrigger);

let url = new URL(window.location, 'https://ct.co.uk');

let loader = document.createElement('div');
loader.className = 'lds-ripple';
loader.appendChild(document.createElement('div'));
loader.appendChild(document.createElement('div'));

const blockAccessWrap = document.querySelector('.block-access-form');
const blockAccessForm = document.getElementById('block-access-form');

if (blockAccessForm) {
	blockAccessForm.addEventListener('submit', (event) => {
		event.preventDefault();
		let formData = new FormData(blockAccessForm);
		blockAccessWrap.classList.add('ajaxing');
		blockAccessWrap.append(loader);
		formData.append('action', 'block_access_form');

		axios
			.post(ajaxurl, formData)
			.then((response) => {
				// console.log(response);
				blockAccessWrap.classList.remove('ajaxing');
				loader.remove();
				blockAccessWrap.innerHTML = response.data;
				ScrollTrigger.refresh();
				// send GA conversion
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					event: 'formSubmission',
					formType: 'Gated Block Access',
					formPage: formData.get('service'),
				});
			})
			.catch((error) => {
				console.log(error);
				blockAccessForm.classList.remove('ajaxing');
				loader.remove();
			});
	});
}
